<script>
  import { onDestroy, onMount } from "svelte";
  import { injectAuditLogCss } from "../lib/gruimModuleTheme";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../lib/mountFederatedSvelteComponent";

  let el1;
  let grappleAuditLogInstance = null;

  const formatDateTime = (value) => {
    const raw = String(value ?? "");
    if (!raw) return "";

    const parsed = new Date(raw);
    return Number.isNaN(parsed.getTime()) ? raw : parsed.toLocaleString();
  };

  const mountGrappleAuditLog = async () => {
    try {
    const module = await import("App/alaceGrappleAuditLog");
    const GrappleAuditLog = module.default;

    if (el1) {
      grappleAuditLogInstance = mountFederatedSvelteComponent(
        grappleAuditLogInstance,
        GrappleAuditLog,
        {
          target: el1,
          props: {
          translation: {
            actedAt: "Acted At",
            actedOn: "Acted On",
            actionKey: "Action Key",
            entityId: "Entity ID",
            before: "Before",
            after: "After",
          },
          schema: {
            visibility: {
              readOnly: true,
            },
            "field-properties": {
              "auto-generated-fields": ["id"],
              "field-order": [
                "actedAt",
                "actor",
                "action",
                "actedOn",
                "actionKey",
                "entityId",
                "before",
                "after",
              ],
              "field-transformation": [
                {
                  name: "actedAt",
                  transformation: (value) => formatDateTime(value),
                },
              ],
            },
          },
          },
        }
      );
    }
    } catch (err) {
      console.warn("alaceGrappleAuditLog module unavailable:", err);
    }
  };

  onMount(() => {
    injectAuditLogCss();
    void mountGrappleAuditLog();
  });

  onDestroy(() => {
    grappleAuditLogInstance = destroySvelteComponentInstance(grappleAuditLogInstance);
  });
</script>

<div class="audit-log-dark" bind:this={el1} />
